// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__1Ks1h","col":"Table_col__CIF57","fulfillmentStatus":"Table_fulfillmentStatus__16jP2","emailCol":"Table_emailCol__2Ey-U"};